var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "22px",
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Accounts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DataGate-LP---Action-Buttons",
    transform: "translate(-812.000000, -359.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Accounts",
    transform: "translate(812.000000, 359.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3,9.9 L15.2982,15.3 L2.7,15.3 L2.7,9.9 L15.3,9.9 Z M15.3,8.1 L2.7,8.1 C1.7073,8.1 0.9,8.9073 0.9,9.9 L0.9,17.1 C0.9,18.0927 1.7073,18.9 2.7,18.9 L8.1,18.9 L8.1,19.8 L5.4,19.8 L5.4,21.6 L12.6,21.6 L12.6,19.8 L9.9,19.8 L9.9,18.9 L15.3,18.9 C16.2927,18.9 17.1,18.0927 17.1,17.1 L17.1,9.9 C17.1,8.9073 16.2927,8.1 15.3,8.1 L15.3,8.1 Z",
    id: "Fill-702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,2.7 C4.5,1.7064 3.6936,0.9 2.7,0.9 C1.7046,0.9 0.9,1.7064 0.9,2.7 C0.9,3.6936 1.7046,4.5 2.7,4.5 C3.6936,4.5 4.5,3.6936 4.5,2.7",
    id: "Fill-703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7,4.5 C1.2087,4.5 0,5.7087 0,7.2 L5.4,7.2 C5.4,5.7087 4.1904,4.5 2.7,4.5",
    id: "Fill-704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8,1.8 C10.8,0.8064 9.9936,0 9,0 C8.0046,0 7.2,0.8064 7.2,1.8 C7.2,2.7936 8.0046,3.6 9,3.6 C9.9936,3.6 10.8,2.7936 10.8,1.8",
    id: "Fill-705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,3.6 C7.5087,3.6 6.3,4.8087 6.3,6.3 L11.7,6.3 C11.7,4.8087 10.4904,3.6 9,3.6",
    id: "Fill-706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1,2.7 C17.1,1.7064 16.2936,0.9 15.3,0.9 C14.3046,0.9 13.5,1.7064 13.5,2.7 C13.5,3.6936 14.3046,4.5 15.3,4.5 C16.2936,4.5 17.1,3.6936 17.1,2.7",
    id: "Fill-707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3,4.5 C13.8087,4.5 12.6,5.7087 12.6,7.2 L18,7.2 C18,5.7087 16.7904,4.5 15.3,4.5",
    id: "Fill-708"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/accounts.668d1dc6f75f7d1f06c2d2fd22487845.svg";
export { ForwardRef as ReactComponent };